import { AttachmentsStore } from './attachments.store';
import { Attachment } from '../models/attachment.model';
import { Injectable } from '@angular/core';
import { AttachmentsQuery } from './attachments.query';
import { asArray } from '../../../search/musimap-filters/musimap-common/musimap-common.utils';

const normalizeStoreEntityId = (storeEntityId: number | string): number => +storeEntityId;

@Injectable({
  providedIn: 'root'
})
export class AttachmentsRepository {
  constructor(private store: AttachmentsStore, private query: AttachmentsQuery) {}

  forceUpdateAttachments(entityId: number | string, attachmentsToUpdate: Attachment[]): void {
    const storeEntityId = normalizeStoreEntityId(entityId);
    const { attachments } = this.query.getEntity(storeEntityId) || {};
    const updated = new Map<number | string, Attachment>(attachmentsToUpdate.map(d => [d.id, d]));
    const updatedAttachments = [];

    (attachments || attachmentsToUpdate || []).forEach(d => {
      const updatedAttachment = updated.get(d.id);
      if (updatedAttachment) {
        updatedAttachments.push(updatedAttachment);
        updated.delete(d.id);
      } else {
        updatedAttachments.push(d);
      }
    });

    if (updated.size) {
      Array.from(updated.values()).forEach(d => updatedAttachments.push(d));
    }

    this.store.upsert(storeEntityId, {
      storeEntityId,
      attachments: updatedAttachments
    });
  }

  addAttachment(entityId: number | string, attachment: Attachment): void {
    const storeEntityId = normalizeStoreEntityId(entityId);
    const { attachments } = this.query.getEntity(entityId) || {};
    const updatedAttachments = attachments?.length ? [...attachments, attachment] : [attachment];

    this.store.upsert(storeEntityId, {
      storeEntityId,
      attachments: updatedAttachments
    });
  }

  deleteAttachment(entityId: number, attachment: Attachment): void {
    const storeEntityId = normalizeStoreEntityId(entityId);
    const { attachments } = this.query.getEntity(storeEntityId);
    const updatedAttachments = attachments.filter(item => item.id !== attachment.id);
    this.store.upsert(storeEntityId, {
      storeEntityId,
      attachments: updatedAttachments
    });
  }

  deleteEntities(storeEntityIds: number[]): void {
    this.store.remove(asArray(storeEntityIds).map(normalizeStoreEntityId));
  }
}
